export default "__VITE_ASSET__C7Jys8Gr__"